/* Wizard footer (React port of m0.js footer/wire). Back + Continue, with the
   Continue label flipping to "Confirm & Apply" on the last real step. */
import React from 'react'
import PropTypes from 'prop-types'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CheckIcon from '@mui/icons-material/Check'

export default function WizardFooter({showBack, last, disabled, onBack, onNext}) {
  return (
    <div
      className='row gap12'
      style={{display: 'flex', gap: 12, marginTop: 20, justifyContent: 'flex-end'}}
    >
      {showBack ? (
        <button type='button' className='btn' onClick={onBack}>
          <ArrowBackIcon style={{width: 16, height: 16}} />
          Back
        </button>
      ) : null}
      <button type='button' className='btn btn-primary' disabled={disabled} onClick={onNext}>
        {last ? 'Confirm & Apply' : 'Continue'}{' '}
        {last ? (
          <CheckIcon style={{width: 16, height: 16}} />
        ) : (
          <ArrowForwardIcon style={{width: 16, height: 16}} />
        )}
      </button>
    </div>
  )
}

WizardFooter.propTypes = {
  showBack: PropTypes.bool,
  last: PropTypes.bool,
  disabled: PropTypes.bool,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
}
